import { motion, AnimatePresence } from "framer-motion";
import { Skull, ShieldAlert, DoorOpen } from "lucide-react";
import { useState } from "react";

export default function AgeGate({ onVerify }) {
  const [denied, setDenied] = useState(false);

  return (
    <motion.div
      data-testid="age-gate-modal"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-void/95 backdrop-blur-md p-4"
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="absolute inset-0 halftone opacity-20 pointer-events-none" />
      <motion.div
        initial={{ scale: 0.9, opacity: 0, rotate: -1 }}
        animate={{ scale: 1, opacity: 1, rotate: 0 }}
        transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
        className="relative w-full max-w-lg border-4 border-blooddeep bg-pulp comic-shadow p-8 sm:p-10"
      >
        <div className="absolute -top-5 -right-4 rotate-6 bg-blooddeep text-bone font-marker text-sm px-3 py-1 ink-shadow-sm">
          BEWARE: 18+ BEYOND
        </div>
        <AnimatePresence mode="wait">
          {denied ? (
            <motion.div
              key="denied"
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-center"
            >
              <DoorOpen className="mx-auto mb-4 text-crimson" size={48} />
              <h2 className="font-display text-2xl sm:text-3xl text-paper mb-4">
                THE CRYPT REJECTS THE WEAK
              </h2>
              <p className="font-type text-sm text-paper/70 mb-8">
                Crawl back to the daylight, lamb. These pages thirst for braver souls.
              </p>
              <button
                data-testid="age-gate-retry-button"
                onClick={() => setDenied(false)}
                className="font-impact uppercase tracking-wider bg-blooddeep text-white border-2 border-black px-6 py-3 ink-shadow crimson-glow transition-all duration-150 hover:-translate-y-0.5 hover:bg-crimson active:translate-x-1 active:translate-y-1"
              >
                Wait — I am 18+
              </button>
            </motion.div>
          ) : (
            <motion.div key="ask" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <div className="flex items-center gap-3 mb-6">
                <Skull className="text-crimson crimson-glow" size={36} />
                <span className="font-display text-xl text-paper tracking-wide">ATROCITY COMIX</span>
              </div>
              <h1 className="font-impact text-3xl sm:text-4xl uppercase leading-none text-paper mb-4">
                Dare you <span className="text-crimson">enter the crypt</span>?
              </h1>
              <p className="font-marker text-bloodglow text-base mb-2 -rotate-1 inline-block">
                Your momma warned you about girls like these.
              </p>
              <p className="font-type text-sm text-paper/60 mb-8 flex items-center gap-2">
                <ShieldAlert size={16} className="text-crimson shrink-0" />
                Gothic horror, blood, and untamed femme fatales. Adults only.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button
                  data-testid="age-gate-yes-button"
                  onClick={() => {
                    localStorage.setItem("atrocity-age-verified", "yes");
                    onVerify();
                  }}
                  className="flex-1 font-impact uppercase tracking-wider text-lg bg-blooddeep text-bone border-2 border-black px-6 py-4 ink-shadow crimson-glow transition-all duration-150 hover:-translate-y-0.5 hover:bg-crimson active:translate-x-1 active:translate-y-1"
                >
                  I am 18+ — Enter
                </button>
                <button
                  data-testid="age-gate-no-button"
                  onClick={() => setDenied(true)}
                  className="flex-1 font-impact uppercase tracking-wider text-lg bg-transparent text-paper border-2 border-paper/40 px-6 py-4 transition-colors duration-150 hover:border-paper hover:text-bloodglow"
                >
                  I fear the dark
                </button>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    </motion.div>
  );
}
